import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/register"].some((u) => cfg.url?.includes(u));
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const CURRENCIES = { XOF: { label: "FCFA", decimals: 0 }, XAF: { label: "FCFA", decimals: 0 } };
export const registerCurrencies = (countries) =>
  countries.forEach((c) => { CURRENCIES[c.currency] = { label: c.currency_label, decimals: c.decimals ?? 0 }; });
export const currencyInfo = (cur) => CURRENCIES[cur || "XOF"] || { label: cur, decimals: 2 };
export const fcfa = (n, cur = "XOF") => {
  const { label, decimals } = currencyInfo(cur);
  return `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: decimals }).format(n || 0)} ${label}`;
};
export const imgUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

export const ORDER_STATUS = {
  recue: "Commande reçue",
  confirmee: "Confirmée",
  preparation: "En préparation",
  expediee: "Expédiée",
  annulee: "Annulée",
};
export const ORDER_FLOW = ["recue", "confirmee", "preparation", "expediee"];
export const SHOP_STATUS = { pending: "En attente", approved: "Approuvée", rejected: "Refusée", suspended: "Suspendue" };
export const SUB_STATUS = { pending: "En attente de paiement", payment_verified: "Paiement vérifié", active: "Activé", expired: "Expiré", rejected: "Refusé", revoked: "Accès retiré" };
